import styled from 'styled-components';
import { Tooltip, FormGroup as ReactFormGroup } from 'react-bootstrap';
import { BsFillInfoCircleFill } from 'react-icons/bs';

import formAlertImg from 'assets/images/form-alert.png';

export const ModalHeader = styled.div`
  background: ${(props) => props.theme.color.bg.secondary};
  svg {
    cursor: pointer;
  }
`;

export const ModalHeaderSection = styled.p`
  color: ${(props) => props.theme.color.text.secondary};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ModalHeaderTitle = styled.h1`
  color: ${(props) => props.theme.color.text.inverse};
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const SaveInvoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 32px;
`;

export const InfoReplaceContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 18px;
  border: 1px solid #f2f2f2;
  border-radius: 3px;
  align-items: center;
  padding: 8px;
  margin-bottom: 10px;
`;

export const InfoReplaceContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  h3 {
    font-family: ${(props) => props.theme.font.title.family};
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    font-size: ${(props) => props.theme.font.title.size.h3};
    line-height: ${(props) => props.theme.font.title.lineHeight.h3};
    color: ${(props) => props.theme.color.text.primary};
  }

  p {
    font-size: ${(props) => props.theme.font.body.family};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    font-size: ${(props) => props.theme.font.body.size.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.regular};
    color: ${(props) => props.theme.color.text.primary};
  }
`;

export const InvoiceInfo = styled.div`
  /* padding: 0 16px; */
  gap: 24px;
`;

export const InvoiceInfoTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  h2 {
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #999999;
  }
`;

export const InvoiceInfoData = styled.div`
  display: flex;
  justify-content: center;
`;

export const InfoData = styled.span`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 16px;
  color: ${(props) => props.theme.color.text.secondary};
`;

export const Icon = styled.img`
  position: relative;
  top: -2px;
`;

export const InfoIcon = styled(BsFillInfoCircleFill)`
  size: 16px;
  color: #999999;
  cursor: pointer;
`;

export const ConsumerUnitInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 50px 0 50px;
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #f2f2f2;

  .consumer-unit-info-label {
    font-family: 'Montserrat';
    font-weight: 400;
    font-size: 16px;
    text-align: center;

    b {
      font-weight: 700;
    }
  }
`;

export const ConsumerUnitCardContainer = styled.div`
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.color.ui.shade2};
  overflow: hidden;
  position: relative;
`;

export const CardImage = styled.div`
  width: 100%;
  height: 150px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const Company = styled.div`
  width: 80px;
  height: 80px;
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 110px;
  right: 8px;
  img {
    max-width: 64px;
    max-height: 64px;
  }
`;

export const CompanyImg = styled.img`
  max-width: 95px;
  max-height: 95px;
`;

export const InfoTitle = styled.p`
  color: ${(props) => props.theme.color.text.tertiary};
  font-size: 20px;
  font-family: Poppins;
  font-weight: 700;
`;

export const InfoAddress = styled.p`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 400;
  /* text-align: end; */
`;

export const CardDataContainer = styled.div`
  width: 100%;
  padding: 20px 32px;
`;

export const MonthGenerationContainer = styled.div`
  p {
    font-family: 'Montserrat';
    font-weight: 400;
    font-size: 16px;
    text-align: center;
  }
  form {
    /* background-color: red; */
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const Cancel = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: ${(props) => props.theme.color.text.disabled};
  cursor: pointer;
  display: flex;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 38px;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.color.ui.shade3};
  margin-right: 32px;
`;

export const Button = styled.button`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background-color: ${(props) => props.theme.color.ui.orange};
  color: ${(props) => props.theme.color.text.inverse};
  border-radius: 3px;
  border-width: 0;
  display: flex;
  height: 38px;
  padding: 0px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  :hover {
    filter: brightness(0.95);
  }
`;

export const FormGroup = styled(ReactFormGroup)<{ hasError: boolean }>`
  input {
    border-bottom-color: ${(props) => (props.hasError ? '#f42121' : '#e6e6e6')};
    background-image: ${(props) => props.hasError && `url(${formAlertImg})`};
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: calc(100% - 12px);
  }
  span {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: #f42121;
  }
`;

export const FormLabel = styled.label`
  display: flex;
  gap: 10px;
  color: ${(props) => props.theme.color.text.disabled};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  margin-bottom: 8px;
`;

export const FormInput = styled.input`
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.shade2};
  background: ${(props) => props.theme.color.bg.primary};
  box-shadow: 0px 0px 0px 0px #cbdafc;
  padding: 0px 12px;
  height: 48px;
  color: ${(props) => props.theme.color.text.primary};
  font-family: 'Montserrat';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  &::placeholder {
    color: ${(props) => props.theme.color.text.disabled};
  }
  &:focus {
    outline: none;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const InvoiceTooltip = styled(Tooltip)`
  background-color: ${(props) => props.theme.color.bg.primary};
`;

export const NoExpectedGenerationInline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  background: ${(props) => props.theme.color.bg.warning};
  border: 1px solid ${(props) => props.theme.color.ui.yellow};
  border-radius: 3px;
  height: 100%;

  svg {
    font-size: 20px;
    color: ${(props) => props.theme.color.ui.orange};
  }

  p {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: ${(props) => props.theme.color.text.primary};
    text-align: left;
  }

  button {
    align-self: flex-start;
    padding: 6px 16px;
    background-color: ${(props) => props.theme.color.ui.orange};
    color: ${(props) => props.theme.color.text.inverse};
    border: none;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      filter: brightness(0.95);
    }
  }
`;

// Aviso "promoção a GD" (Opção B) — a fatura indica geração própria numa UC
// antes marcada como não-GD; ao salvar, a UC vira GD e o usuário é encaminhado
// ao cadastro da usina/monitoramento.
export const PromotionNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 16px 0;
  padding: 14px 16px;
  background: ${(props) => props.theme.color.bg.warning};
  border: 1px solid ${(props) => props.theme.color.ui.yellow};
  border-radius: 3px;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 20px;
    color: ${(props) => props.theme.color.ui.orange};
  }

  p {
    margin: 0;
    font-size: 13px;
    color: ${(props) => props.theme.color.text.primary};
    text-align: left;
  }
`;
